import { packItems } from "@/mocks/evidence";

export default function EvidenceKit() {
  return (
    <section id="pack" className="w-full bg-foreground-950">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div>
            <p className="eyebrow text-xs font-semibold text-accent-300">06 / 证据整理包</p>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
              一份打包好的证据，<br className="hidden md:block" />
              省去跨平台拼凑
            </h2>
            <p className="mt-5 max-w-md text-sm leading-7 text-background-200/85 md:text-[15px]">
              归档按日期分类，实锤截图、聊天记录、录音视频与复核说明合成一本。离线也能逐页对照，无需登录、无需跳转。
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a
                href="#download"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-download-cloud-2-line text-lg" />
                下载本周证据整理包
              </a>
              <span className="text-xs text-background-200/60">PDF · 约 128MB · 0926 版</span>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            {packItems.map((p) => (
              <a
                key={p.title}
                href="#download"
                className="group flex items-center gap-4 rounded-lg border border-background-100/15 bg-background-50/5 p-4 transition-colors hover:bg-background-50/10"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-background-50/10 text-accent-300">
                  <i className={`${p.icon} text-xl`} />
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="whitespace-nowrap font-heading text-base font-semibold text-background-50">
                      {p.title}
                    </h3>
                    <span className="whitespace-nowrap rounded-full bg-primary-500/20 px-2.5 py-0.5 text-[11px] text-accent-300">
                      {p.tag}
                    </span>
                  </div>
                  <p className="mt-1 truncate text-xs text-background-200/70">{p.desc}</p>
                  <p className="mt-1.5 text-[11px] text-background-200/50">{p.meta}</p>
                </div>
                <i className="ri-arrow-right-line text-accent-300 opacity-0 transition-opacity group-hover:opacity-100" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}